._AddToListButton_1tqjg_1 {
  width: 220px;
}